import React from "react";
import { GenericTableView } from "./view";
import { styles } from "./styles";

export const GenericTable = props => (
  <GenericTableView {...props} styles={styles} />
);
